<template>
  <div>
    <station-layer-group
      v-for="group in activeStationGroups"
      :key="group.band"
      :stations="group.stations"
      :name="group.name"
      :pinging-satellite-names="pingingSatelliteNames"
      :focus-satellite="focusSatellite"
      :get-station-icon="getStationIcon"
    />
  </div>
</template>

<script setup>
import { computed } from 'vue'
import StationLayerGroup from './StationLayerGroup.vue'

const props = defineProps({
  stations: {
    type: Array,
    required: true
  },
  pingingSatelliteNames: {
    type: Array,
    required: true
  },
  focusSatellite: {
    type: String,
    default: null
  },
  getStationIcon: {
    type: Function,
    required: true
  }
})

const activeStationGroups = computed(() => {
  const groups = [
    { band: 137, name: '137 stations', filter: p => typeof p.autoTune === 'number' && p.autoTune === 137 },
    { band: 433, name: '400-440 stations', filter: p => typeof p.autoTune === 'number' && p.autoTune === 433 },
    { band: 900, name: '868-915 stations', filter: p => typeof p.autoTune === 'number' && p.autoTune === 900 },
    { band: 2400, name: '2400 stations', filter: p => typeof p.autoTune === 'number' && p.autoTune === 2400 },
    { band: null, name: 'null band stations', filter: p => p.autoTune === null }
  ]

  return groups
    .map(group => ({
      ...group,
      stations: props.stations.filter(group.filter)
    }))
    .filter(group => group.stations && group.stations.length > 0)
})
</script>